import { RemoteGetUserByCpf } from 'data/usecases';
import { makeApiUrlUsers } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetUserByCpf = (): RemoteGetUserByCpf => {
  return new RemoteGetUserByCpf(makeApiUrlUsers(), makeAxiosHttpClient());
};
